import type { CountryCode } from '~/core/i18n'
import { COUNTRY_CODE } from '~/core/i18n'
import { COMPANY_NAME } from '~/constants/contacts'
import type { Contacts } from '~/features/contacts/types'

export const INFO = {
  [COUNTRY_CODE.RU]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
  [COUNTRY_CODE.KZ]: {
    workingHours: 'С 10:00 до 19:00 по времени Астаны',
    address: 'г. Астана, район Сарыарка, ул. Тараса Шевченко, здание 4/1, н.п. 7',
    postAddress: 'Z11A3X4,Республика Казахстан, город Астана, район Сарыарка, улица Тарас Шевченко, здание 4/1, офис 507',
    mapCoords: [51.160370, 71.403156],
    balloonTemplate: 'Казахстан, Астана',
  },
  [COUNTRY_CODE.BY]: {
    workingHours: 'С 8:00 до 17:00 по времени Минска',
    address: 'город Минск, пер. 3-й Можайского, 11, помещение 109',
    postAddress: '',
    mapCoords: [53.943165, 27.581280],
    balloonTemplate: 'Беларусь, Минск',
  },
  [COUNTRY_CODE.KG]: {
    workingHours: 'С 11:00 до 20:00 по времени Бишкека',
    address: 'г. Бишкек, Октябрьский район, мкрн.6, 34, 88',
    postAddress: '',
    mapCoords: [42.824242, 74.622916],
    balloonTemplate: 'Кыргызстан, Бишкек',
  },
  [COUNTRY_CODE.UZ]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
  [COUNTRY_CODE.TJ]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
  [COUNTRY_CODE.MD]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
  [COUNTRY_CODE.AM]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
  [COUNTRY_CODE.GE]: {
    workingHours: 'С 8:00 до 17:00 по времени Москвы',
    address: 'г. Краснодар, ул. Буденного, д. 182, 8 - 11 этажи',
    postAddress: `350000, г. Краснодар, а/я 3272, ${COMPANY_NAME}`,
    mapCoords: [45.034693, 38.979589],
    balloonTemplate: 'Россия, Краснодар',
  },
} satisfies Record<CountryCode, {
  workingHours: string
  address: string
  postAddress: string
  mapCoords: [number, number]
  balloonTemplate: string
}>

export const CONTACTS = {
  [COUNTRY_CODE.RU]: {
    moderation: {
      phones: [
        {
          text: '8 800 600-30-28',
          raw: '+78006003028',
        },
        {
          text: '8 918 990-13-96',
          raw: '+79189901396',
        },
      ],
      email: 'proverka@prodoctorov.ru',
    },
    support: {
      phones: [
        {
          text: '8 800 707-31-29',
          raw: '+78007073129',
        },
      ],
      email: 'help@medrocket.ru',
    },
    director: {
      email: 'help@medrocket.ru',
    },
  },
  [COUNTRY_CODE.KZ]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.BY]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.KG]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.UZ]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.TJ]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.MD]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.GE]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
  [COUNTRY_CODE.AM]: {
    moderation: {
      email: 'proverka@medrocket.me',
    },
    support: {
      email: 'help@medrocket.me',
    },
    director: {
      email: 'help@medrocket.me',
    },
  },
} satisfies Record<CountryCode, Contacts>

